<agpr-take-over-panel
    [id]="id + '_takeOverPanel'"
    class="agpr-manuallyAddCoverageDialog-takeOverPanel"
    header="Briefings.addCoverage.manual"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="800"
    [maxPanelWidth]="1000"
    (visibleChange)="doHide()"
>
    <agpr-add-mentions-widget
        #addMentionsWidget
        [id]="id + '_addMentionsWidget'"
        [mentionBadges]="mentionBadges"
        (searchMentionsChange)="setAvailableMentions($event)"
        (selectedMentionsChange)="setSelectedMentions($event)"
        (addMentions)="addMentions()"
        [showSortOrder]="true"
    ></agpr-add-mentions-widget>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="close"
            [style]="buttonTypes.secondary"
            (click)="hideSlideOverlay = true"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <div class="agpr-manuallyAddCoverageDialog-footerRight">
            <label [id]="id + '_addToSectionAutocompleteLabel'">
                {{ 'Briefings.addCoverage.manual.addToSection' | localize }}
            </label>
            <agpr-autocomplete
                [id]="id + '_autocomplete'"
                class="agpr-manuallyAddCoverageDialog-autocomplete"
                [placeholder]="'Briefings.importTool.autoSort' | localize"
                [suggestions]="destinationOptions$"
                [customOptions]="customOptions"
                labelField="label"
                [dropdown]="true"
                [(ngModel)]="selectedDestination"
                (itemSelected)="selectDestination($event)"
                (clear)="selectDestination(null)"
                [clearOnBlur]="false"
                [ariaLabelledBy]="id + '_addToSectionAutocompleteLabel'"
            ></agpr-autocomplete>

            <agpr-button
                [id]="id + '_addMentionsButton'"
                label="add"
                (click)="addMentions()"
                [style]="buttonTypes.primary"
            ></agpr-button>
        </div>
    </ng-template>
</agpr-take-over-panel>
